
import React, { useState } from "react";
import { Calendar } from "primereact/calendar";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useNavigate } from "react-router-dom";
import { createAPIEndpointOddLotConversion, EndpointOddLotConversion } from "../../Services/OddLotConversion/OddLotConversionService";
import storage from "../../Services/Storage";
import { toast } from "react-toastify";

const OddLotConversionAllRecords = () => {
    const nav = useNavigate();
    const [startDate, setStartDate] = useState(() => {
        let date = new Date();
        date.setDate(date.getDate() - 7);
        return date;
    });
    const [endDate, setEndDate] = useState(new Date());
    const [allOddLotData, setAllOddLotData] = useState();
    const auth = storage.getLocal("user");

    const getAllOddLotData = async () => {
        const formattedStartDate = new Intl.DateTimeFormat("en-GB").format(startDate);
        const formattedEndDate = new Intl.DateTimeFormat("en-GB").format(endDate);
        try {
            const res = await createAPIEndpointOddLotConversion().get(`${EndpointOddLotConversion.GetAllOddLotData}?FinYrStart=${formattedStartDate}&FinYrEnd=${formattedEndDate}&UserId=${auth.UserId}&CompId=${auth.CompId}`);
            console.log("res.data ", res);
            setAllOddLotData(res.data.Data);
            if (res.data.Data.length == 0) {
                toast.warning(
                    "No data found",
                    {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 2000,
                    }
                );
            }
        } catch (error) {
            console.log("error ", error);
        }
    };

    const handleMovetoNew = () => {
        console.log("navigation called ");
        nav("/inventorymanagement/OddLotConversion");
    };
    return (
        <>
            <div className="col-12 pt-0 pb-4">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h3 className="py-2">Odd Lot Conversion</h3>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="float-end mb-2">
                            {/* <Link to="inventorymanagement/OddLotConversion"> */}
                            <button type="submit" title='Add New' className="btn btn-primary" onClick={handleMovetoNew} >
                                Add New
                            </button>
                            {/* </Link> */}
                        </div>
                    </div>
                </div>
                <section className="sales-box">
                    <div className="row d-flex justify-content-end align-items-end">
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <div className="d-block mb-2">
                                <label className="form-label">From Date </label>
                                <Calendar value={startDate}
                                    onChange={(e) => setStartDate(e.value)}
                                    showIcon
                                    dateFormat="dd/mm/yy" />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <div className="d-block mb-2">
                                <label className="form-label">To Date</label>
                                <Calendar value={endDate}
                                    onChange={(e) => setEndDate(e.value)}
                                    showIcon
                                    dateFormat="dd/mm/yy" />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <div className="float-end mb-2">
                                <button type="submit" title='Download' className="btn btn-primary" onClick={getAllOddLotData}>
                                    Get Data
                                </button>
                            </div>
                        </div>

                    </div>
                </section>
                <section className="">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <h3 className="py-2">Records</h3>
                        <div className="DataTable">
                            <DataTable
                                paginator
                                rows={10}
                                value={allOddLotData}
                                filterDisplay="row"
                                rowsPerPageOptions={[10, 25, 50]}
                                scrollHeight="80vh"
                                // showGridlines
                                scrollable
                                stripedRows
                                emptyMessage="No Record found"
                            >
                                <Column field="MASK_WH_CODE" header="Warehouse"
                                    filterMatchMode="contains"
                                    filter
                                    filterPlaceholder="Search Here..."></Column>
                                <Column field="STK_ADJ_NO" header="Stock Adjustment No"
                                    filter
                                    filterMatchMode="contains"
                                    filterPlaceholder="Search Here..." />
                                <Column field="STOCK_ADJUSTMENT_DATE" header="Date "
                                    filter
                                    filterPlaceholder="Search Here..."></Column>

                            </DataTable>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default OddLotConversionAllRecords;